var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"ml-auto no-flex mb-0 truncate",class:{ 'otra-tienda' : _vm.opUid !== _vm.opUidActual}},[_c('v-icon',[_vm._v("location_on")]),_vm._v("\n    "+_vm._s(_vm.nombre)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }